import api from './axios'

/**
 * Authentication API
 */
export const authApi = {
    /**
     * Login with email and password (form ID determined automatically)
     */
    login: async (email, password) => {
        const response = await api.post('/auth/login', {
            email,
            password,
        })
        return response
    },

    /**
     * Logout
     */
    logout: async () => {
        const response = await api.post('/auth/logout')
        return response
    },

    /**
     * Refresh token
     */
    refresh: async () => {
        const response = await api.post('/auth/refresh')
        return response
    },

    /**
     * Get current user
     */
    me: async () => {
        const response = await api.get('/auth/me')
        return response
    },
}

export default authApi
